import { Component, OnChanges, Input, SimpleChanges, Output, EventEmitter, ViewChild, Renderer2, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CompanyBranchService } from 'src/app/configurations/company-branch/company-branch.service';
import { PurchasesService } from 'src/app/inventory/purchases/purchases.service';
import { ObjectNames, Severity, Status } from 'src/app/inventory/constants/constants';
import { UtilsService } from 'src/app/inventory/purchases/utility/utils.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { AppMainService } from 'src/app/app-main.service';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { UtilityService } from '../../../../inventory/sales-order/utils/utility.service';
import { MulticurrencyPipe } from '../../pipes/multicurrency.pipe';
import { CustomNumberFormatPipe } from '../../pipes/custom-number-format.pipe';
import { ImportserialService } from '../../services/importserial.service';
import { forkJoin, catchError, of, Subject, takeUntil } from 'rxjs';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AddYearPipe } from 'src/app/shared/pipes/add-year.pipe';
import { debounceTime } from "rxjs/operators";
import { SalesOrderService } from 'src/app/inventory/sales-order/sales-order.service';
import { ProductsService } from 'src/app/inventory/products/products.service';
import { IPostingPeriodDetails } from '../posting-period-selector/models/posting-period.model';
import { TaxSelectionModel } from '../tax-selection-modal/models/tax.model';

@Component({
  selector: 'app-edit-itemreceipt',
  templateUrl: './edit-itemreceipt.component.html',
  styleUrls: ['./edit-itemreceipt.component.scss'],
  providers: [CustomNumberFormatPipe, MulticurrencyPipe]
})
export class EditItemreceiptComponent implements OnChanges, OnInit {

  @Input() selectedReceived = null;
  @Input() selectedChannel: any = null;
  @Input() baseCurrency: any;
  @Input() orgCurrency = [];
  @Input() isViewMode: boolean = false;
  @Output() onClose = new EventEmitter<boolean>();
  @Output() loadList = new EventEmitter<boolean>();
  uomCategory = [];
  length: number = 0;
  qtyDecimal: number = 0;
  receiveGreaterQty: boolean = false;
  poSerialEnabled: boolean = false;
  receiptForm: FormGroup;
  itemReceiptTemplate: any = null;
  receivePurchaseListTB = [];
  valueOptions = [];
  allShippingTerms = [];
  allShippingTermsDD = [];
  discountEnabled: boolean = false;
  allDiscounts = [];
  allVendorsDD = [];
  allFOBPoints = [];
  allLocations = [];
  productOwner = [];
  displayVendorAddress: boolean = false;
  selectedVendorAddress = null;
  selectedVendorContact = null;
  displayVendorContact: boolean = false;
  vendorDetails = null;
  selectedVendorDD = null;
  rowsPerPageTB = [100, 200, 300, 500];
  rowsPerPage = [100, 200, 300, 500];
  importCount: number = 0;
  pageNumber: number = 1;
  pageSize: number = 15;
  totalTBRecord: number = 0;
  totalRecords: number = 0;
  first: number = 0;
  selectedPOList = [];
  poList = [];
  globalFilterInput: string = '';
  poTBCol = ObjectNames.receivedItemsConstants.poTableCols;
  displayPOList: boolean = false;
  shipAddress = null;
  isDisabled: boolean = false;
  displayPODialog: boolean = false;
  statementMessege: string = '';
  minDate: Date = new Date(1988, 0, 1);
  maxDate: Date = new Date(2050, 11, 31);
  bulkImportAvailble: boolean = false;
  allClosed: boolean = false;
  allReceived: boolean = false;
  rpoDetail: any = null;
  orderTotal: number = 0;
  subTotal: number = 0;
  discount: number = 0;
  tax: number = 0;
  lineTotal: number = 0;
  discountAmount: number = 0;
  shippingAmount: number = 0;
  vendorPaymentTermsDD = [];
  vendorPaymentMethodsDD = [];
  vendorShippingMethodsDD = [];
  ordersVendorAddrNew;
  ordersVendorCityNew;
  ordersVendorStateNew;
  ordersVendorCountryNew;
  ordersVendorZipcodeNew;
  ordersVendorContactNew;
  ordersVendorPhoneNew;
  noPOFindOrLoadingText: string = 'Loading...';
  selectedValueOption = null;
  modelChanged = new Subject<string>();
  //tracking
  refId: string = '';
  displayImport: boolean = false;
  disabledSave: boolean = false;
  trackingForm: FormGroup;
  isPrefix: boolean = false;
  allChecked: boolean = false;
  selectedProductForScan;
  nameLists = [];
  trackingOptions = [];
  systemTrackingData = [];
  autoGenerateLists = [];
  listLength: number = 0;
  selectedBundle;
  displayScanInfo: boolean = false;
  savedOptionSelection = null;
  isAutoGenerated: boolean = false;
  prefixValue = '';

  protected ngUnsubscribe$: Subject<void> = new Subject<void>();
  @ViewChild('editor') editor: any;

  /**postingperiod**/
  currentPostingPeriodInfo!: IPostingPeriodDetails;
  updatedPostingPeriodInfo!: IPostingPeriodDetails;
  isAllowPostingPeriod: boolean = false;

  /**tax**/
  taxSettings: any;
  taxConfig: any;
  allTaxRates: any[] = []; // account based taxes
  displayTaxSelectionDialog: boolean = false;
  selectedTax: any;
  appliedTax: any;
  currentProduct: any;
  currentProductType: string;
  taxDialogContext: 'product' | 'footer' | null = null;
  footerTaxEnabled: boolean = false;

  constructor(private companyService: CompanyBranchService, private purchaseService: PurchasesService, private fb: FormBuilder,
    public utilsService: UtilsService, private app: AppMainComponent, private appMainService: AppMainService,
    private datePipe: DatePipe, private utilityService: UtilityService, private multicurrency: MulticurrencyPipe,
    private messageService: MessageService, private confirmationService: ConfirmationService, private titlecasePipe: TitleCasePipe,
    private addYearPipe: AddYearPipe, private importService: ImportserialService, private renderer: Renderer2,
    private salesOrderService: SalesOrderService, private productsService: ProductsService) {
    this.modelChanged.pipe(
      debounceTime(700))
      .subscribe(() => {
        this.getSelectedVendorDetails(this.receiptForm.controls['vendorId']?.value?.id, this.globalFilterInput);
      })
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.receiptForm = this.fb.group({
      vendorId: ['', [Validators.required]],
      checkWithoutBill: [false],
      shippingAddressId: [0],
      paymentTermId: [0],
      paymentMethodId: [0],
      shippingMethodId: [0],
      shippingTermId: [0],
      contactId: [0],
      userId: [0],
      notes: [''],
      createdDate: [this.app._showDateTimeWithZone(new Date())],
      referenceNo: ['']
    });
    this.prepareTrackingForm();
    const vendorObservable = this.purchaseService.getVendorListByPO(false).pipe(catchError((error) => this.handleError("Vendor", error)));
    const locationObservable = this.purchaseService.getAllLocations().pipe(catchError((error) => this.handleError("Location", error)));
    const templateObservable = this.purchaseService.getPOConfigurations('Purchase').pipe(catchError((error) => this.handleError("Template", error)));
    const shippingTermsObservable = this.purchaseService.getShippingTermList().pipe(catchError((error) => this.handleError("ShippingTerm", error)));
    const fobPointsObservable = this.purchaseService.getFOBList().pipe(catchError((error) => this.handleError("FOB", error)));
    const discountsObservable = this.salesOrderService.getDiscounts(false).pipe(catchError((error) => this.handleError("Discount", error)));
    const trackingOptionsObservable = this.purchaseService.loadTrackingOptions().pipe(catchError((error) => this.handleError("tracking", error)));
    const uomCategoryObservable = this.purchaseService.loadAllUOMCategory().pipe(catchError((error) => this.handleError("uom", error)));
    const salesRepObservable = this.productsService.getProductOwner(this.app.companyId).pipe(catchError((error) => this.handleError("users", error)));
    forkJoin([vendorObservable, locationObservable, templateObservable, shippingTermsObservable, fobPointsObservable,
      discountsObservable, trackingOptionsObservable, uomCategoryObservable, salesRepObservable]).subscribe(
        ([vendorData, locData, templateData, shippingData, fobData, discountData, trackingOptionData, categoryData, salesRepData]) => {
          this.allVendorsDD = vendorData;
          this.loadAllLocations(locData);
          this.getPOSettings(templateData);
          this.loadShippingTerm(shippingData);
          this.loadFOBList(fobData);
          this.getAllDiscounts(discountData);
          this.getAllTrackingData(trackingOptionData);
          this.loadUOMCategory(categoryData);
          this.loadISettings();
          this.loadSalesRep(salesRepData);
          this.appMainService.isHideSpinner("loadData");
          if (changes.selectedReceived?.currentValue) {
            this.getRPODetails(this.selectedReceived?.id)
          }
        },
        (error) => {
          this.appMainService.isHideSpinner("loadData");
          this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
        },
      );
  }

  ngOnInit(): void {
    this.importService.getDecimalValue().subscribe(value => {
      if (value) {
        this.length = value;
      }
    })
    this.importService.getQtyDecimalValue().subscribe(value => {
      if (value) {
        this.qtyDecimal = value;
      }
    })
  }

  async getShipAddress(address) {
    this.shipAddress = address;
    await this.getTaxByAddress(this.shipAddress?.address?.countryId);
  }

  openRpoEditor() {
    this.isViewMode = false;
    this.receiptForm?.enable();
  }

  loadISettings() {
    const settings = this.utilityService.getISettings();
    const settingsMap = new Map(settings?.map(s => [s.code, s.enabled]));
    this.receiveGreaterQty = settingsMap.get('receiveqty');
    this.poSerialEnabled = settingsMap.get('poserialenabled');
    this.isAllowPostingPeriod = settingsMap.get('posting') ?? false;
  }

  loadSalesRep(usersData) {
    if (usersData) {
      this.productOwner = usersData?.filter(user => user.statusId == Status.Active);
    }
  }

  getRPODetails(rpoId) {
    this.receivePurchaseListTB = [];
    this.appMainService.isShowSpinner('itemReceipt');
    this.purchaseService.getRPOById(rpoId).subscribe(res => {
      this.appMainService.isHideSpinner('itemReceipt');
      this.rpoDetail = res;
      const currentYear = this.app._showDateTimeWithZone(this.rpoDetail.createdDate).getFullYear();
      this.minDate = new Date(currentYear, 0, 1);
      this.maxDate = new Date(currentYear, 11, 31);
      this.currentPostingPeriodInfo = {
        postingDate: this.app._showDateTimeWithZone(this.rpoDetail.postingDate),
        postingMonth: this.rpoDetail.postingMonth,
        postingYear: this.rpoDetail.postingYear
      };
      this.receiptForm.patchValue(res);
      this.receiptForm.controls['checkWithoutBill'].setValue(!res.isBillCreated);
      this.getShipAddress(this.rpoDetail.warehouse);
      this.itemReceiptTemplate = (res.configJson ? JSON.parse(res.configJson) : this.itemReceiptTemplate);
      this.footerTaxEnabled = !this.itemReceiptTemplate?.labels_table[9]?.isChecked && this.itemReceiptTemplate?.labels_footer[4]?.isChecked;
      const filteredVendor = this.allVendorsDD.find(vendor => vendor.id === this.rpoDetail.vendorId);
      this.receiptForm.controls['vendorId'].setValue(filteredVendor);
      this.getSelectedVendorDetails(filteredVendor?.id, '')
      this.ordersVendorAddrNew = (this.rpoDetail?.purchaseOrder?.billingAddress?.streetAddress1 ?? '') + '' + (this.rpoDetail?.purchaseOrder?.billingAddress?.streetAddress2 ?? '');
      this.ordersVendorCityNew = this.rpoDetail?.purchaseOrder?.billingAddress?.city?.name;
      this.ordersVendorStateNew = this.rpoDetail?.purchaseOrder?.billingAddress?.state?.name;
      this.ordersVendorCountryNew = this.rpoDetail?.purchaseOrder?.billingAddress?.country?.name;
      this.ordersVendorZipcodeNew = this.rpoDetail?.purchaseOrder?.billingAddress?.zipCode;
      this.ordersVendorPhoneNew = this.rpoDetail?.purchaseOrder?.contact?.contactPhones[0]?.phone?.number
      this.ordersVendorContactNew = this.rpoDetail?.purchaseOrder?.contact?.firstName + ' ' + this.rpoDetail?.purchaseOrder?.contact?.lastName;
      this.receiptForm.controls['createdDate'].setValue(this.app._showDateTimeWithZone(this.rpoDetail.createdDate));
      this.subTotal = Number(res.totalAmount) * Number(res.exchangeRate);
      const notes = res.receivedPurchaseOrderNotes[res?.receivedPurchaseOrderNotes?.length - 1]?.note?.comment ?? "";
      this.receiptForm.controls['notes'].setValue(notes);
      this.setContentInEditor(notes);
      this.shippingAmount = Number(res.shippingChargeAmount) * Number(res.exchangeRate);
      this.orderTotal = Number(res.netAmount) * Number(res.exchangeRate);
      this.discount = Number(res.discountAmount) * Number(res.exchangeRate);
      this.selectedValueOption = this.allDiscounts?.find(opt => opt.id == res.discountId);
      if (this.selectedValueOption?.type?.name == 'Percentage') {
        const discountTypeValue = Number(this.rpoDetail.discountAmount * 100) / Number(this.rpoDetail.totalAmount);
        this.discountAmount = (isNaN(discountTypeValue) ? 0 : discountTypeValue);
      } else {
        this.discountAmount = this.rpoDetail?.discountAmount;
      }
      const inActiveShippingTerm = this.allShippingTermsDD?.find(v => v.id == this.rpoDetail?.shippingTermId);
      if (!inActiveShippingTerm) {
        this.vendorShippingMethodsDD.push(this.rpoDetail?.shippingTerm);
      }
      const filteredTermMethod = this.allShippingTerms?.find(p => p.id == this.rpoDetail.shippingTermId);
      this.receiptForm.controls['shippingTermId'].setValue(filteredTermMethod);
      if (res.receivedPurchaseOrderProducts.length > 0) {
        for (let l of res.receivedPurchaseOrderProducts) {
          const bundleProducts: any[] = [];
          if (l.receivedPurchaseBundleDetail?.length > 0) {
            for (let prd of l.receivedPurchaseBundleDetail) {
              let eachProduct = {
                id: prd.id,
                fromDB: true,
                productId: prd.productId,
                subProductId: prd.subProductId,
                receivedPurchaseOrderProductId: prd.receivedPurchaseOrderProductId,
                receivedPurchaseOrderId: l.receivedPurchaseOrderId,
                itemNo: prd.product?.itemNo,
                typeId: prd.product?.typeId,
                description: prd?.description,
                quantity: prd.orderedQty,
                quantityReceive: prd.qtyReceived,
                originalQtyReceive: prd.qtyReceived,
                originalQtyPending: prd.qtyPending,
                quantityPending: prd.qtyPending,
                currentVal: prd.orderedQty,
                unit: prd.product?.productUOM.find(uom => uom.unitOfMeasureId == prd.productUnitId),
                uom: prd.product?.productUOM,
                cost: parseFloat(prd.totalAmount).toFixed(this.length),
                pricePerProduct: parseFloat(prd.pricePerProduct).toFixed(this.length),
                isClosed: prd.isClosed,
                isForceClosed: prd.isForceClosed,
                receivedProductStatus: prd.receivedProductStatus,
                tax: prd.tax?.name,
                taxId: prd.taxId,
                taxRate: prd.taxRate,
                taxTypeId: prd.taxTypeId,
                taxFinancialId: prd.taxFinancialId,
                purchaseOrderId: l.purchaseOrderId,
                purchaseOrderNo: l.purchaseOrderNo,
                taxName: prd.taxName,
                discountAmount: prd.discountAmount,
                discountType: prd.discountType?.description,
                discountTypeId: prd.discountTypeId,
                discountFinancialId: prd.discountFinancialId,
                discountId: prd.discountId,
                discountName: prd.discountName,
                trackingEnabled: prd.product?.isTrackingRequired,
                serialSettings: (prd.product?.serialSettings ? JSON.parse(prd.product?.serialSettings) : null),
                receivedPurchaseOrderBundleSerialDetail: prd.receivedPurchaseOrderBundleSerialDetail,
                serialCount: prd.serialCount
              };
              bundleProducts.push(eachProduct);
            }
          }
          let eachProduct = {
            id: l.id,
            fromDB: true,
            productId: l.productId,
            itemNo: l.product?.itemNo,
            receivedPurchaseOrderId: l.receivedPurchaseOrderId,
            receivedPurchaseOrderProductId: l.id,
            description: l?.description,
            uom: l.product?.productUOM,
            unit: l.product?.productUOM?.find(uom => uom.unitOfMeasureId == l.productUnitId),
            uomCategory: this.utilsService.isCountCategory(this.uomCategory, l.product?.productUOM?.find(uom => uom.unitOfMeasureId == l.productUnitId)?.uomDetail?.categoryId),
            warehouseId: l.warehouseId,
            quantity: l.orderedQty,
            quantityReceive: l.qtyReceived,
            originalQtyReceive: l.qtyReceived,
            quantityPending: l.qtyPending,
            originalQtyPending: l.qtyPending,
            pricePerProduct: (Number(l.pricePerProduct) * Number(res.exchangeRate)).toFixed(this.length),
            cost: Number(l.totalAmount) * Number(res.exchangeRate),
            lineTotal: Number(l.netAmount) * Number(res.exchangeRate),
            isClosed: l.isClosed,
            isForceClosed: l.isForceClosed,
            purchaseOrderId: l.purchaseOrderId,
            purchaseOrderNo: l.purchaseOrderNo,
            receivedProductStatus: l.receivedProductStatus,
            tax: l.tax?.name,
            taxId: l.taxId,
            taxRate: l.taxRate,
            taxTypeId: l.taxTypeId,
            taxFinancialId: l.taxFinancialId,
            taxName: l.taxName,
            discountAmount: l.discountAmount,
            discountType: l.discountType?.description,
            discountTypeId: l.discountTypeId,
            discountFinancialId: l.discountFinancialId,
            discountId: l.discountId,
            discountName: l.discountName,
            typeId: l.product?.typeId,
            trackingEnabled: l.product?.isTrackingRequired,
            serialSettings: (l.product?.serialSettings ? JSON.parse(l.product?.serialSettings) : null),
            ReceivedPurchaseOrderSerialDetail: l.receivedPurchaseOrderSerialDetail,
            products: bundleProducts,
            serialCount: l.serialCount,
            productSubTax: l.receivedPOProductSubTax,
            taxAmount: l.receivedPOProductSubTax?.reduce((sum, s) => sum + (Number(s.taxAmount) * res?.exchangeRate), 0).toFixed(this.length)
          };
          this.receivePurchaseListTB.push(eachProduct);
        }
      }
      this.lineTotal = this.receivePurchaseListTB?.reduce((sum, item) => sum + Number(item.lineTotal), 0);
      this.tax = this.receivePurchaseListTB?.reduce((sum, item) => sum + Number(item.taxAmount), 0);
      //check whether bulk import option available or not
      this.bulkImportAvailble = this.utilsService.checkforBulkImportPurchase(this.receivePurchaseListTB);
      if (this.isViewMode) {
        this.receiptForm?.disable();
      }
      this.displayPODialog = true;
    })
  }

  isClosingStatementDate(event: string) {
    this.statementMessege = event;
  }

  loadVendors(vendor) {
    this.allVendorsDD = vendor
  }

  loadAllLocations(locations) {
    for (let loc of locations) {
      loc.customName = loc.name + ' - ' + loc.locationId;
    }
    this.allLocations = locations;
  }

  getPOSettings(configs) {
    const purchaseTemplate = configs?.find(config => config.name == 'Purchase Template');
    if (purchaseTemplate?.configurationDetails.length > 0) {
      const allPurchaseTemplates = JSON.parse(purchaseTemplate?.configurationDetails[0].configJSONValue);
      this.itemReceiptTemplate = allPurchaseTemplates?.find((t) => t.producttypeId == this.selectedChannel?.id);
    }
  }


  loadShippingTerm(terms) {
    this.allShippingTerms = terms;
    this.allShippingTermsDD = this.allShippingTerms?.filter(shTerm => shTerm.statusId == Status.Active);
  }

  getAllDiscounts(addDiscounts) {
    if (addDiscounts && addDiscounts.length > 0) {
      this.allDiscounts = addDiscounts?.map((l) => ({ ...l, additionalDescription: `${l.description}(${l.type.description})`, typeDescription: l.type.description }));
      this.selectedValueOption = null;
    }
  }

  getAllTrackingData(opt) {
    this.trackingOptions = opt;
  }

  loadFOBList(points) {
    if (points) {
      this.allFOBPoints = points;
    }
  }

  loadUOMCategory(cat) {
    if (cat) {
      this.uomCategory = cat;
    }
  }

  onRowSelectAddress() {
    this.displayVendorAddress = false;
    this.receiptForm.controls['shippingAddressId'].setValue(this.selectedVendorAddress.addressId);
    this.ordersVendorAddrNew = (this.selectedVendorAddress.address?.streetAddress1 == '') ? this.selectedVendorAddress.address?.streetAddress2 : (this.selectedVendorAddress.address?.streetAddress1 + ' ' + this.selectedVendorAddress.address?.streetAddress2);
    this.ordersVendorCityNew = this.selectedVendorAddress.address?.city?.name;
    this.ordersVendorStateNew = this.selectedVendorAddress.address?.state?.name;
    this.ordersVendorCountryNew = this.selectedVendorAddress.address?.country?.name;
    this.ordersVendorZipcodeNew = this.selectedVendorAddress.address?.zipCode;
    if (this.selectedVendorAddress.address.attnContactId) {
      for (let vendorContact of this.vendorDetails.vendorContacts) {
        if (vendorContact.contactId == this.selectedVendorAddress.address.attnContactId) {
          this.ordersVendorPhoneNew = vendorContact.contact?.contactPhones[0]?.phone?.number;
          this.ordersVendorContactNew = vendorContact.contact?.firstName + " " + vendorContact.contact?.lastName;
        }
      }
    } else {
      for (let vendorContact of this.vendorDetails.vendorContacts) {
        if (vendorContact.contact?.isPrimaryContact) {
          this.ordersVendorPhoneNew = vendorContact.contact?.contactPhones[0]?.phone?.number;
          this.ordersVendorContactNew = vendorContact.contact?.firstName + " " + vendorContact.contact?.lastName;
        }
      }
    }
  }

  changeVendorContact() {
    this.selectedVendorContact = null;
    this.selectedVendorContact = this.vendorDetails?.vendorContacts?.find(contact => contact.contactId === this.receiptForm.controls['contactId'].value);
    this.displayVendorContact = true;
  }

  onRowSelectContact() {
    this.receiptForm.controls['contactId'].setValue(this.selectedVendorContact.contactId);
    this.ordersVendorPhoneNew = this.selectedVendorContact.contact?.contactPhones[0]?.phone?.number;
    this.ordersVendorContactNew = this.selectedVendorContact.contact?.firstName + " " + this.selectedVendorContact.contact?.lastName;
    this.displayVendorContact = false;
  }

  removeProduct(index) {
    this.receivePurchaseListTB.splice(index, 1);
    this.findsum(this.receivePurchaseListTB);
  }

  getData(event) {
    this.pageNumber = (event.first / event.rows) + 1;
    this.pageSize = event.rows;
    //this.first=event.first;
    this.getSelectedVendorDetails(this.receiptForm.controls['vendorId']?.value?.id, this.globalFilterInput);
  }

  get vendorExchangeRate() {
    return (this.orgCurrency?.find(cr => cr.currencyId == this.vendorDetails?.currencyId)?.exchangeRate);
  }


  getSelectedVendorDetails(vendorId, search) {
    this.appMainService.isShowSpinner('itemReceipt');
    this.selectedPOList = [];
    this.poList = [];
    this.purchaseService.getPOListByVendor(this.pageNumber, this.pageSize, vendorId, search, this.rpoDetail?.id).subscribe(data => {
      this.getVendorDetails(data.vendor);
      if (data.purchaseOrder.item2.length > 0) {
        this.totalRecords = data.purchaseOrder.item1;
        for (let purchase of data.purchaseOrder.item2) {
          const purchaseEach = {
            id: purchase.id,
            poNo: purchase.number,
            poDate: this.datePipe.transform(this.app._showDateTimeWithZone(purchase.poDate), 'MM/dd/yyyy'),
            amount: this.multicurrency.transform(purchase.netAmount, (this.vendorExchangeRate ?? this.baseCurrency?.exchangeRate), (this.vendorDetails?.currencyUnit?.symbol ?? this.baseCurrency?.symbol), this.length),
            products: purchase.purchaseOrderProducts,
          }
          this.poList.push(purchaseEach);
        }
      } else {
        this.noPOFindOrLoadingText = "No Records Found."
      }
    })
  }

  getVendorDetails(vendorDetails) {
    this.vendorDetails = vendorDetails;
    this.selectedVendorAddress = null;
    //Active Vendor Payment Term
    this.vendorPaymentTermsDD = this.vendorDetails?.vendorPaymentTerm?.filter(term => term.statusId == Status.Active);
    const inActivePaymnetTerm = this.vendorPaymentTermsDD?.find(v => v.paymentTermId == this.rpoDetail?.paymentTermId);
    if (!inActivePaymnetTerm && this.rpoDetail?.paymentTerm) {
      const obj = {
        paymentTermId: this.rpoDetail?.paymentTerm?.id,
        statusId: this.rpoDetail?.paymentTerm?.statusId,
        paymentMethodTerm: this.rpoDetail?.paymentTerm?.name,
      }
      this.vendorPaymentTermsDD.push(obj);
    }
    // Payment Term which is not part of vendor (WF PO)
    const nonVendorPaymentTerm = this.vendorDetails?.vendorPaymentTerm?.find(v => v.paymentTermId == this.rpoDetail?.paymentTermId);
    if (!nonVendorPaymentTerm && this.rpoDetail?.paymentTerm) {
      const obj = {
        paymentTermId: this.rpoDetail?.paymentTerm?.id,
        statusId: this.rpoDetail?.paymentTerm?.statusId,
        paymentMethodTerm: this.rpoDetail?.paymentTerm?.name,
      }
      this.vendorPaymentTermsDD.push(obj);
    }
    //Set Payment Term
    this.receiptForm.controls['paymentTermId'].setValue(this.vendorPaymentTermsDD?.find(term => term.paymentTermId == this.rpoDetail.paymentTermId));
    //Active Vendor Payment Method
    this.vendorPaymentMethodsDD = this.vendorDetails?.vendorPaymentMethod?.filter(method => method.statusId == Status.Active);
    const inActivePaymentMethod = this.vendorPaymentMethodsDD?.find(v => v.paymentMethodId == this.rpoDetail?.paymentMethodId);
    if (!inActivePaymentMethod && this.rpoDetail?.paymentMethod) {
      const obj = {
        paymentMethodId: this.rpoDetail?.paymentMethod?.id,
        statusId: this.rpoDetail?.paymentMethod?.statusId,
        paymentMethodMethod: this.rpoDetail?.paymentMethod?.name,
      }
      this.vendorPaymentMethodsDD.push(obj);
    }
    // Payment Method which is not part of vendor (WF PO)
    const nonVendorPaymentMethod = this.vendorDetails?.vendorPaymentMethod?.find(v => v.paymentMethodId == this.rpoDetail?.paymentMethodId);
    if (!nonVendorPaymentMethod && this.rpoDetail?.paymentMethod) {
      const obj = {
        paymentMethodId: this.rpoDetail?.paymentMethod?.id,
        statusId: this.rpoDetail?.paymentMethod?.statusId,
        paymentMethodMethod: this.rpoDetail?.paymentMethod?.name,
      }
      this.vendorPaymentMethodsDD.push(obj);
    }
    //Set Payment Method
    this.receiptForm.controls['paymentMethodId'].setValue(this.vendorPaymentMethodsDD?.find(method => method.paymentMethodId == this.rpoDetail.paymentMethodId));
    //Active Vendor Shipping Method
    this.vendorShippingMethodsDD = this.vendorDetails?.vendorShippingMethod?.filter(shipping => shipping.statusId == Status.Active);
    const inActiveShippingMethod = this.vendorShippingMethodsDD?.find(v => v.shippingMethodId == this.rpoDetail?.shippingMethodId);
    if (!inActiveShippingMethod && this.rpoDetail?.shippingMethod) {
      const obj = {
        shippingMethodId: this.rpoDetail?.shippingMethod?.id,
        statusId: this.rpoDetail?.shippingMethod?.statusId,
        shippingMethodName: this.rpoDetail?.shippingMethod?.name,
      }
      this.vendorShippingMethodsDD.push(obj);
    }
    // Shipping Method which is not part of vendor (WF PO)
    const nonVendorShippingMethod = this.vendorDetails?.vendorShippingMethod?.find(v => v.shippingMethodId == this.rpoDetail?.shippingMethodId);
    if (!nonVendorShippingMethod && this.rpoDetail?.shippingMethod) {
      const obj = {
        shippingMethodId: this.rpoDetail?.shippingMethod?.id,
        statusId: this.rpoDetail?.shippingMethod?.statusId,
        shippingMethodName: this.rpoDetail?.shippingMethod?.name,
      }
      this.vendorShippingMethodsDD.push(obj);
    }
    //Set Shippong Method
    this.receiptForm.controls['shippingMethodId'].setValue(this.vendorShippingMethodsDD?.find(method => method.shippingMethodId == this.rpoDetail?.shippingMethodId));
    this.appMainService.isHideSpinner('itemReceipt');
  }

  onChangeVendor(value, type) {
    const activeVendorAddresses = value.vendorAddresses?.filter(add => add.statusId == Status.Active); //Active Address
    if (activeVendorAddresses.length > 1 && type == 'edit') {
      this.selectedVendorDD = value;
      this.selectedVendorDD.vendorAddresses = value.vendorAddresses?.filter(add => add.statusId == Status.Active); //Active Address
      this.selectedVendorAddress = this.selectedVendorDD.vendorAddresses?.find(add => add.addressId == this.receiptForm.controls['shippingAddressId'].value);
      this.displayVendorAddress = true;
    } else {
      this.ordersVendorAddrNew = '';
      this.ordersVendorCityNew = '';
      this.ordersVendorStateNew = '';
      this.ordersVendorCountryNew = '';
      this.ordersVendorZipcodeNew = '';
      this.ordersVendorPhoneNew = '';
      this.ordersVendorContactNew = '';
      for (let vendorContact of value.vendorContacts) {
        if (vendorContact.contact?.isPrimaryContact) {
          this.receiptForm.controls['contactId'].setValue(vendorContact.contactId);
          this.ordersVendorPhoneNew = vendorContact.contact?.contactPhones[0]?.phone?.number;
          this.ordersVendorContactNew = vendorContact.contact?.firstName + " " + vendorContact.contact?.lastName;
        }
      }
    }
    this.appMainService.isHideSpinner('itemReceipt');
  }

  private handleError(apiName: string, error: any) {
    this.appMainService.isHideSpinner("loadData");
    this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
    return of(null);
  }

  changed(event) {
    this.modelChanged.next("");
  }

  openPO() {
    this.selectedPOList = [];
    this.receivePurchaseListTB?.forEach(element => {
      const po = this.poList?.find(po => po.id == element.purchaseOrderId);
      const duplicate = this.selectedPOList.find(po => po.id == element.purchaseOrderId);
      if (po && !duplicate) {
        this.selectedPOList.push(po);
      }
    });
    this.displayPOList = true;
  }


  addPO() {
    this.displayPOList = false;
    //remove unSelected PO items from existing list
    const receivePurchaseListTBCopy = JSON.parse(JSON.stringify(this.receivePurchaseListTB));
    const removedPO = receivePurchaseListTBCopy?.filter(item => !this.selectedPOList.some(_item => _item.id === item.purchaseOrderId));
    for (let removed of removedPO) {
      const remove = receivePurchaseListTBCopy?.find(itm => itm.purchaseOrderId == removed.purchaseOrderId);
      if (remove) {
        const index = receivePurchaseListTBCopy.indexOf(remove);
        this.receivePurchaseListTB.splice(index, 1)
      }
    }
    const allProducts = [];
    for (let po of this.selectedPOList) {
      for (let prd of po.products) {
        if (prd.product?.typeId != 4) {
          const present = this.receivePurchaseListTB?.find(prod => prod.productId == prd.productId && prod.purchaseOrderId == prd.purchaseOrderId);
          if (!present) {
            allProducts.push(prd);
          }
        } else {
          allProducts.push(prd);
        }
      }
    }
    //this.receivePurchaseListTB = [];
    if (allProducts.length > 0) {
      for (let l of allProducts) {
        const bundleProducts: any[] = [];
        if (l.purchaseBundleDetail?.length > 0) {
          for (let prd of l.purchaseBundleDetail) {
            let eachProduct = {
              id: prd.id,
              purchaseOrderId: prd.purchaseOrderId,
              purchaseOrderNo: prd.purchaseOrderNo,
              productId: prd.productId,
              subProductId: prd.subProductId,
              purchaseOrderProductId: prd.purchaseOrderProductId,
              itemNo: prd.product?.itemNo,
              typeId: prd.product?.typeId,
              description: prd.product?.description,
              quantity: prd.quantity,
              fromDB: prd.isClosed,
              quantityReceive: (prd.isClosed ? prd.qtyReceived : 0),
              originalQtyReceive: (prd.isClosed ? prd.qtyReceived : 0),
              originalQtyPending: prd.qtyPending,
              quantityPending: prd.qtyPending,
              currentVal: prd.quantity,
              uom: prd.product.productUOM,
              unit: prd.product?.productUOM?.find(uom => uom.unitOfMeasureId == prd.productUnitId),
              totalAmount: parseFloat(prd.totalAmount).toFixed(this.length),
              pricePerProduct: parseFloat(prd.pricePerProduct).toFixed(this.length),
              cost: 0,
              isClosed: prd.isClosed,
              isForceClosed: false,
              isReceiveFull: false,
              isDisabled: prd.isDisabled,
              trackingEnabled: prd.product?.isTrackingRequired,
              serialSettings: (prd.product?.serialSettings ? JSON.parse(prd.product?.serialSettings) : null),
              receivedPurchaseOrderBundleSerialDetail: []
            };
            bundleProducts.push(eachProduct);
          }
        }
        let eachProduct = {
          id: 0,
          productId: l.productId,
          purchaseOrderId: l.purchaseOrderId,
          purchaseOrderNo: l.purchaseOrderNo,
          itemNo: l.product?.itemNo,
          description: l.product?.description,
          uom: l.product?.productUOM,
          unit: l.product?.productUOM?.find(uom => uom.unitOfMeasureId == l.productUnitId),
          quantity: l.quantity,
          fromDB: l.isClosed,
          quantityReceive: (l.isClosed ? l.qtyReceived : 0),
          originalQtyReceive: (l.isClosed ? l.qtyReceived : 0),
          originalQtyPending: l.qtyPending,
          quantityPending: l.qtyPending,
          pricePerProduct: parseFloat(l.pricePerProduct).toFixed(this.length),
          cost: 0,
          lineTotal: 0,
          taxAmount: 0,
          isClosed: l.isClosed,
          isForceClosed: false,
          isDisabled: l.isDisabled,
          products: bundleProducts,
          typeId: l.product?.typeId,
          trackingEnabled: l.product?.isTrackingRequired,
          serialSettings: (l.product?.serialSettings ? JSON.parse(l.product?.serialSettings) : null),
          isReceiveFull: false,
          ReceivedPurchaseOrderSerialDetail: [],
          productSubTax: (this.footerTaxEnabled ? (this.receivePurchaseListTB[0]?.productSubTax ?? []) : [])
        };
        if (eachProduct.typeId !== 4) {
          this.receivePurchaseListTB.push(eachProduct);
        } else {
          const existingBundle = this.receivePurchaseListTB?.find(prd => (prd.productId == eachProduct.productId && prd.purchaseOrderId == eachProduct.purchaseOrderId));
          if (existingBundle) {
            const unique = eachProduct.products?.filter(obj2 => !existingBundle.products?.some(obj1 => obj1.subProductId == obj2.subProductId));
            existingBundle.isClosed = (unique?.length > 0 ? false : true);
            existingBundle.products?.push(...unique)
          } else {
            this.receivePurchaseListTB.push(eachProduct);
          }
        }
      }
    }
    this.findsum(this.receivePurchaseListTB);
  }

  calculateProductPrice(product) {
    if (!product.isClosed) {
      if (product.fromDB) {
        product.quantityPending = Number(product.quantity - product.quantityReceive) < 0 ? 0 : Number(product.quantity - product.quantityReceive);
      } else {
        product.quantityPending = (Number(product.originalQtyPending) - Number(product.quantityReceive) < 0 ? 0 :
          Number(product.originalQtyPending) - Number(product.quantityReceive));
      }
    }
    this.subTotal = 0;
    this.lineTotal = 0;
    product.cost = (!isNaN(product.quantityReceive * product.pricePerProduct * product.unit?.uomDetail?.value) ? Number(product.quantityReceive * product.pricePerProduct * product.unit?.uomDetail?.value) : (product.pricePerProduct * product.quantityReceive));
    let productsTotalTax = 0;
    product?.productSubTax?.forEach((sTax) => {
      productsTotalTax += this.utilityService.calculateProductsTax(sTax.taxRate, product.cost);
    });
    product.taxAmount = productsTotalTax;
    product.lineTotal = (!isNaN(product.quantityReceive * product.pricePerProduct * product.unit?.uomDetail?.value) ? Number(product.quantityReceive * product.pricePerProduct * product.unit?.uomDetail?.value) : Number(product.quantityReceive * product.pricePerProduct)) +
    (this.footerTaxEnabled ? 0 :  product.taxAmount);
    for (let prd of this.receivePurchaseListTB) {
      this.subTotal = Number(this.subTotal + prd.cost);
      this.lineTotal = this.lineTotal + Number(prd.lineTotal);
    }
    this.findsum(this.receivePurchaseListTB);
  }

  calculateBundlePrice(bundle, product) {
    if (!bundle.isClosed) {
      this.subTotal = 0;
      if (product.fromDB) {
        product.quantityPending = Number(product.quantity - product.quantityReceive) < 0 ? 0 : Number(product.quantity - product.quantityReceive);
      } else {
        product.quantityPending = (Number(product.originalQtyPending) - Number(product.quantityReceive) < 0 ? 0 :
          Number(product.originalQtyPending) - Number(product.quantityReceive));
      }
      product.cost = Number(product.quantityReceive * product.pricePerProduct * product.unit?.uomDetail?.value);
      bundle.cost = 0;
      for (let prd of bundle.products) {
        bundle.cost = Number(bundle.cost) + Number(prd.cost);
      }
      for (let prd of this.receivePurchaseListTB) {
        this.subTotal = Number(this.subTotal + prd.cost);
      }
      this.findsum(this.receivePurchaseListTB);
    }
  }

  findsum(data, addDiscount?) {
    this.subTotal = 0;
    this.orderTotal = 0;
    this.lineTotal = 0;
    if (addDiscount === false) {
      this.discountAmount = this.selectedValueOption?.discountValue || 0;
    }
    if (data && data.length > 0) {
      for (let prd of this.receivePurchaseListTB) {
        this.subTotal = Number(this.subTotal + prd.cost);
        this.lineTotal = this.lineTotal + Number(prd.lineTotal);
      }
      if (this.selectedValueOption?.type?.name == 'Percentage') {
        this.discount = Number(this.subTotal * (this.discountAmount / 100));
      } else if (this.selectedValueOption?.type?.name == 'Amount') {
        this.discount = Number(this.discountAmount);
      }
      this.tax = 0;
      this.tax = this.receivePurchaseListTB?.reduce((sum, s) => sum + Number(s.taxAmount), 0) ?? 0;
      this.orderTotal = Number((this.lineTotal + (this.lineTotal > 0 ? Number(this.shippingAmount) : 0) +
        (this.footerTaxEnabled ? this.tax : 0) - this.discount));
    }
  }

  receiveFull(event, product) {
    if (event.checked) {
      product.quantityReceive = (product.fromDB ? (Number(product.originalQtyPending) + Number(product.originalQtyReceive)) : Number(product.originalQtyPending));
      this.calculateProductPrice(product);
    } else {
      product.quantityPending = product.originalQtyPending;
      product.quantityReceive = (product.fromDB ? product.originalQtyReceive : 0);
      this.calculateProductPrice(product);
    }
    //set Receivefull Checkbox
    const received = this.receivePurchaseListTB?.filter(p => (p.isReceiveFull && p.typeId != 4));
    const presentProduct = this.receivePurchaseListTB?.filter(p => p.typeId != 4);
    let receivedBundleProduct: any[] = [];
    let presetBundleProduct: any[] = [];
    for (let prd of this.receivePurchaseListTB) {
      if (prd.typeId == 4) {
        for (let bundle of prd.products) {
          presetBundleProduct.push(bundle);
          if (bundle.isReceiveFull) {
            receivedBundleProduct.push(bundle);
          }
        }
      }
    }
    if (received.length == presentProduct.length && receivedBundleProduct.length == presetBundleProduct.length) {
      this.allReceived = true;
    } else {
      this.allReceived = false;
    }
  }


  receiveFullBundle(event, product, bundle) {
    if (event.checked) {
      bundle.quantityReceive = (bundle.fromDB ? (Number(bundle.originalQtyPending) + Number(bundle.originalQtyReceive)) : bundle.originalQtyPending);
      this.calculateBundlePrice(product, bundle);
    } else {
      bundle.quantityPending = product.originalQtyPending;
      bundle.quantityReceive = (product.fromDB ? product.originalQtyReceive : 0);
      this.calculateBundlePrice(product, bundle);
    }
    //Set Receivefull Checkbox
    const received = this.receivePurchaseListTB?.filter(p => (p.isReceiveFull && p.typeId != 4));
    const presentProduct = this.receivePurchaseListTB?.filter(p => p.typeId != 4);
    const receivedBundle = product.products?.filter(p => p.isReceiveFull);
    if (received.length == presentProduct.length && receivedBundle.length == product.products.length) {
      this.allReceived = true;
    } else {
      this.allReceived = false;
    }
  }

  setForciblyProduct(product) {
    if (product.isClosed) {
      product.isForceClosed = true;
    } else {
      product.isForceClosed = false;
      product.isDisabled = false;
    }
  }

  receiveAllCheckbox(event) {
    if (event.checked) {
      for (let prd of this.receivePurchaseListTB) {
        if (!prd.isDisabled && !prd.isClosed) {
          prd.isReceiveFull = true;
          prd.quantityReceive = (prd.fromDB ? (Number(prd.originalQtyPending) + Number(prd.originalQtyReceive)) : Number(prd.originalQtyPending));
          this.calculateProductPrice(prd);
          if (prd.products.length > 0) {
            for (let bundle of prd.products) {
              if (!bundle.isClosed && !bundle.isDisabled) {
                bundle.isReceiveFull = true;
                bundle.quantityReceive = (bundle.fromDB ? (Number(bundle.originalQtyPending) + Number(bundle.originalQtyReceive)) : Number(bundle.originalQtyPending));
                this.calculateBundlePrice(prd, bundle);
              }
            }
          }
        }
      }
    } else {
      for (let prd of this.receivePurchaseListTB) {
        if (!prd.isDisabled) {
          prd.isReceiveFull = false;
          prd.quantityPending = prd.originalQtyPending;
          prd.quantityReceive = (prd.fromDB ? prd.originalQtyReceive : 0);
          this.calculateProductPrice(prd);
          if (prd.products.length > 0) {
            for (let bundle of prd.products) {
              if (!bundle.isDisabled) {
                bundle.isReceiveFull = false;
                bundle.quantityPending = bundle.originalQtyPending;
                bundle.quantityReceive = bundle.originalQtyReceive;
                this.calculateBundlePrice(prd, bundle);
              }
            }
          }
        }
      }
    }
  }

  setAllCheckbox() {
    if (this.allClosed) {
      this.receivePurchaseListTB.forEach(element => {
        if (!element.isReceiveFull && !element.isDisabled && element.quantityPending != 0) {
          element.isClosed = true;
          element.isForceClosed = true;
        }
        if (element.products.length > 0) {
          for (let prd of element.products) {
            if (!prd.isReceiveFull && !prd.isDisabled) {
              prd.isClosed = true;
              prd.isForceClosed = true;
            }
          }
        }
      });
    } else {
      this.receivePurchaseListTB.forEach(element => {
        if (!element.isDisabled) {
          element.isClosed = false;
          element.isForceClosed = false;
        }
        if (element.products.length > 0) {
          for (let prd of element.products) {
            if (!prd.isDisabled) {
              prd.isClosed = false;
              prd.isForceClosed = false;
            }
          }
        }
      });
    }
  }

  /**tracking SerialNo**/
  prepareTrackingForm() {
    const qty = this.selectedProductForScan?.quantityReceive;
    this.trackingForm = this.fb.group({
      qty: [(qty - this.listLength), [Validators.required]],
      lotNo: [""],
      revisionNo: [""],
      expiration: [""],
      serialNo: [""],
      serialNo2: [""],
      serialNo3: [""],
      serialNo4: [""],
      serialNo5: [""],
      serialNo6: [""],
      serialNo7: [""],
      serialNo8: [""],
      serialNo9: [""],
      serialNo10: [""],
      serialNo11: [""],
      serialNo12: [""],
      serialNo13: [""],
      serialNo14: [""],
      serialNo15: [""],
      serialNo16: [""],
      serialNo17: [""],
      packageBarcode: [""],
    });
    /**set validation for Tracking form**/
    for (let opt of this.trackingOptions) {
      if (opt.enabled && (this.savedOptionSelection ? this.savedOptionSelection[`${opt.code}`] : true)) {
        if (opt.field !== 'serialNo' && opt.isRequired) {
          this.trackingForm.get(`${opt.field}`).setValidators(Validators.required);
        } else if (opt.field === 'serialNo' && opt.isRequired) {
          if (this.utilsService.displayName('serializedChecked', this.trackingOptions, 'control') == 'InputBox') {
            this.trackingForm.get(`${opt.field}`).setValidators([Validators.required, Validators.pattern(/^[A-Za-z0-9-]*$/)]);
          } else {
            this.trackingForm.get(`${opt.field}`).setValidators([Validators.required]);
          }
        } else {
          this.trackingForm.get(`${opt.field}`).clearValidators();
        }
        this.trackingForm.get(`${opt.field}`).updateValueAndValidity();
      }
    }
  }

  openScanInfo(product, bundle?) {
    if (this.shipAddress) {
      if (product.quantityReceive > 0) {
        this.selectedProductForScan = product;
        // this.selectedProductForScan.id = 0;
        this.savedOptionSelection = product.serialSettings;
        this.prepareTrackingForm();
        this.displayScanInfo = true;
        this.isPrefix = false;
        this.isAutoGenerated = false;
        this.prefixValue = '';
        this.refId = '';
        this.totalTBRecord = 0;
        const arr: any[] = [];
        if (bundle) {
          this.selectedBundle = bundle;
          this.savedOptionSelection = product.serialSettings;
          if (!product.receivedPurchaseOrderBundleSerialDetail) {
            this.purchaseService.getItemReceiptProductSerialDetails(this.rpoDetail.id, this.selectedProductForScan.productId, this.selectedProductForScan?.subProductId).subscribe(res => {
              product.receivedPurchaseOrderBundleSerialDetail = res;
              product.receivedPurchaseOrderBundleSerialDetail?.forEach((element) => {
                const obj = {
                  id: element.id,
                  receivedPurchaseBundleDetailId: 0,
                  serialNo: element.barcode,
                  lotNo: element.lotNumber,
                  revisionNo: element.revisionNumber,
                  expiration: element.expirationDate && this.app._showDateTimeWithZone(element.expirationDate),
                };
                arr.push(obj);
              });
              this.autoGenerateLists = arr;
              this.nameLists = this.autoGenerateLists.slice(0, 100);
              this.listLength = this.autoGenerateLists.length;
              this.totalTBRecord = this.listLength;
            })
          } else {
            product.receivedPurchaseOrderBundleSerialDetail?.forEach((element) => {
              const obj = {
                id: element.id,
                receivedPurchaseBundleDetailId: 0,
                serialNo: element.barcode,
                lotNo: element.lotNumber,
                revisionNo: element.revisionNumber,
                expiration: element.expirationDate && this.app._showDateTimeWithZone(element.expirationDate),
              };
              arr.push(obj);
            });
            this.autoGenerateLists = arr;
            this.nameLists = this.autoGenerateLists.slice(0, 100);
            this.listLength = this.autoGenerateLists.length;
            this.totalTBRecord = this.listLength;
          }
        } else {
          if (!product.ReceivedPurchaseOrderSerialDetail) {
            this.purchaseService.getItemReceiptProductSerialDetails(this.rpoDetail.id, this.selectedProductForScan.productId, 0).subscribe(res => {
              product.ReceivedPurchaseOrderSerialDetail = res;
              product.ReceivedPurchaseOrderSerialDetail?.forEach((element) => {
                const obj = {
                  id: element.id,
                  serialNo: element.barcode,
                  serialNo2: element.serialNumber2,
                  serialNo3: element.serialNumber3,
                  serialNo4: element.serialNumber4,
                  serialNo5: element.serialNumber5,
                  serialNo6: element.serialNumber6,
                  serialNo7: element.serialNumber7,
                  serialNo8: element.serialNumber8,
                  serialNo9: element.serialNumber9,
                  serialNo10: element.serialNumber10,
                  serialNo11: element.serialNumber11,
                  serialNo12: element.serialNumber12,
                  serialNo13: element.serialNumber13,
                  serialNo14: element.serialNumber14,
                  serialNo15: element.serialNumber15,
                  serialNo16: element.serialNumber16,
                  serialNo17: element.serialNumber17,
                  lotNo: element.lotNumber,
                  revisionNo: element.revisionNumber,
                  expiration: element.expirationDate && this.app._showDateTimeWithZone(element.expirationDate),
                };
                arr.push(obj);
              });
              this.autoGenerateLists = arr;
              this.nameLists = this.autoGenerateLists.slice(0, 100);
              this.listLength = this.autoGenerateLists.length;
              this.totalTBRecord = this.listLength;
              this.trackingForm.controls['qty'].setValue(this.selectedProductForScan.quantityReceive - this.listLength);
            })
          } else {
            product.ReceivedPurchaseOrderSerialDetail?.forEach((element) => {
              const obj = {
                id: element.id,
                serialNo: element.barcode,
                serialNo2: element.serialNumber2,
                serialNo3: element.serialNumber3,
                serialNo4: element.serialNumber4,
                serialNo5: element.serialNumber5,
                serialNo6: element.serialNumber6,
                serialNo7: element.serialNumber7,
                serialNo8: element.serialNumber8,
                serialNo9: element.serialNumber9,
                serialNo10: element.serialNumber10,
                serialNo11: element.serialNumber11,
                serialNo12: element.serialNumber12,
                serialNo13: element.serialNumber13,
                serialNo14: element.serialNumber14,
                serialNo15: element.serialNumber15,
                serialNo16: element.serialNumber16,
                serialNo17: element.serialNumber17,
                lotNo: element.lotNumber,
                revisionNo: element.revisionNumber,
                expiration: element.expirationDate && this.app._showDateTimeWithZone(element.expirationDate),
              };
              arr.push(obj);
            });
            this.autoGenerateLists = arr;
            this.nameLists = this.autoGenerateLists.slice(0, 100);
            this.listLength = this.autoGenerateLists.length;
            this.totalTBRecord = this.listLength;
          }
        }
      } else {
        this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: "Receive quantity must be greater than 0..." });
      }
      this.checkSerialNoInSystem((bundle ? this.selectedProductForScan?.subProductId : this.selectedProductForScan?.productId), this.shipAddress?.id);
    } else {
      this.messageService.add({
        severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error),
        detail: "Please select receiving location first.",
      });
    }
    // Apply the custom validator after initializing the form
    if (!this.utilsService.hasRequiredValidator(this.trackingForm)) {
      this.trackingForm.setValidators(this.utilsService.atLeastOneFieldValidator([
        'lotNo', 'revisionNo', 'expiration',
        'serialNo', 'serialNo2', 'serialNo3', 'serialNo4', 'serialNo5',
        'serialNo6', 'serialNo7', 'serialNo8', 'serialNo9', 'serialNo10',
        'serialNo11', 'serialNo12', 'serialNo13', 'serialNo14', 'serialNo15',
        'serialNo16', 'serialNo17'
      ]));
      this.trackingForm.updateValueAndValidity(); // Ensure validation is applied
    }

  }

  applyDynamicValidation() {
    // Reset validation first
    this.trackingForm.controls['lotNo'].clearValidators();
    this.trackingForm.controls['revisionNo'].clearValidators();
    if (this.savedOptionSelection) {
      const { lotChecked, revisionChecked } = this.savedOptionSelection;

      if (lotChecked && revisionChecked) {
        // Both enabled → Apply validation to LotNo only
        this.trackingForm.controls['lotNo'].setValidators([Validators.required, Validators.pattern(/^(?!\s*$).+/)]);
      } else if (revisionChecked) {
        // Only RevisionNo enabled → Apply validation to RevisionNo
        this.trackingForm.controls['revisionNo'].setValidators([Validators.required, Validators.pattern(/^(?!\s*$).+/)]);
      } else if (lotChecked) {
        // Only LotNo enabled → Apply validation to LotNo
        this.trackingForm.controls['lotNo'].setValidators([Validators.required, Validators.pattern(/^(?!\s*$).+/)]);
      }
      // Ensure form controls update their validation state
      this.trackingForm.controls['lotNo'].updateValueAndValidity();
      this.trackingForm.controls['revisionNo'].updateValueAndValidity();
    }

    // Update the form controls
    this.trackingForm.controls['lotNo'].updateValueAndValidity();
    this.trackingForm.controls['revisionNo'].updateValueAndValidity();
  }

  checkSerialNoInSystem(productId, warehouseId) {
    this.purchaseService.checkSerialNoInSystem(warehouseId, productId, false, this.rpoDetail?.id).subscribe(data => {
      this.systemTrackingData = data;
    })
  }

  countNameList(value) {
    if (this.trackingForm.valid && this.listLength < this.selectedProductForScan?.quantityReceive) {
      if (value.serialNo) {
        value.serialNo = (this.isPrefix ? this.prefixValue.concat(value.serialNo) : value.serialNo);
        const duplicate = this.autoGenerateLists?.filter(sr => sr.serialNo == value.serialNo);
        const present = this.systemTrackingData?.find(sr => sr.serialNo == value.serialNo);
        for (let prd of this.receivePurchaseListTB) {
          const prdDuplicate = prd.ReceivedPurchaseOrderSerialDetail?.filter(sNo => sNo.barcode == value.serialNo);
          if (prdDuplicate?.length > 0) {
            this.messageService.add({
              severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error),
              detail: "Duplicate serialNo found.",
            });
            return
          }
          if (prd.products?.length > 0) {
            for (let bundle of prd.products) {
              const bundleDuplicate = bundle.receivedPurchaseOrderBundleSerialDetail?.filter(sNo => sNo.barcode == value.serialNo);
              if (bundleDuplicate?.length > 0) {
                this.messageService.add({
                  severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error),
                  detail: "Duplicate serialNo found.",
                });
                return
              }
            }
          }
        }
        if (duplicate?.length > 0) {
          this.messageService.add({
            severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error),
            detail: "Serial No you tried to enter is already present in below list.",
          });
        } else if (present) {
          this.messageService.add({
            severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error),
            detail: "Serial No you tried to enter is already present for this product.",
          });
        } else {
          this.checkSerialsForSystem(value.serialNo, this.selectedProductForScan?.id, this.shipAddress?.id, value);
        }
      } else if (!value.serialNo) {
        const totalQty = this.selectedProductForScan?.quantityReceive;
        for (let i = 0; i < (value.qty); i++) {
          if (this.listLength < totalQty) {
            this.autoGenerateLists.push({ ...value });
            this.listLength++;
          }
        }
        this.nameLists = this.autoGenerateLists.slice(0, 100);
        this.totalTBRecord = this.listLength;
        this.trackingForm.controls['qty'].setValue(totalQty - this.listLength);
      }
    }
    const controlNames = Object.keys(this.trackingForm.controls);
    for (let ctrl of controlNames) {
      if (this.trackingOptions?.find((el) => (el.field === ctrl))?.clearField) {
        this.trackingForm.controls[`${ctrl}`].setValue("");
      }
    }
  }

  checkSerialsForSystem(serialNo, productId, warehouseId, value) {
    this.purchaseService.checkSerialNoInAllSystem(serialNo, warehouseId, productId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((res) => {
      if (res.allowSave) {
        this.autoGenerateLists.push(value);
        this.nameLists = this.autoGenerateLists.slice(0, 100);
        this.listLength = this.listLength + 1;
        this.totalTBRecord = this.listLength;
        const totalQty = this.selectedProductForScan?.quantityReceive;
        this.trackingForm.controls['qty'].setValue(totalQty - this.listLength);
      } else {
        this.messageService.add({ severity: "error", summary: "Error", detail: "SerialNo you tried to import is already associated with other product,you can't add." });
      }
    });
  }

  saveSerializedNo(c) {
    if (this.selectedBundle) {
      this.selectedBundle.products?.forEach((element) => {
        if (element.subProductId == this.selectedProductForScan.subProductId) {
          element.receivedPurchaseOrderBundleSerialDetail = [];
          this.autoGenerateLists.forEach((nl) => {
            const obj = {
              id: (nl.id ?? 0),
              createdSource: this.app.userIP,
              updatedSource: this.app.userIP,
              createdBy: this.app.userId,
              updatedBy: this.app.userId,
              createdDate: new Date().toISOString(),
              updatedDate: new Date().toISOString(),
              receivedPurchaseOrderProductId: (this.selectedBundle?.id ? this.selectedBundle.id : 0),
              receivedPurchaseBundleDetailId: (this.selectedProductForScan?.id ? this.selectedProductForScan.id : 0),
              barcode: nl.serialNo,
              serialNumber2: nl.serialNo2,
              serialNumber3: nl.serialNo3,
              serialNumber4: nl.serialNo4,
              serialNumber5: nl.serialNo5,
              serialNumber6: nl.serialNo6,
              serialNumber12: nl.serialNo7,
              serialNumber13: nl.serialNo8,
              serialNumber14: nl.serialNo9,
              serialNumber7: nl.serialNo10,
              serialNumber8: nl.serialNo11,
              serialNumber9: nl.serialNo12,
              serialNumber10: nl.serialNo13,
              serialNumber11: nl.serialNo14,
              serialNumber15: nl.serialNo15,
              serialNumber16: nl.serialNo16,
              serialNumber17: nl.serialNo17,
              lotNumber: nl.lotNo,
              revisionNumber: nl.revisionNo,
              expirationDate: this.app._saveDateTimeWithZone(nl.expiration),
              statusId: 1
            };
            element.receivedPurchaseOrderBundleSerialDetail.push(obj);
          });
        }
      });

    } else {
      this.receivePurchaseListTB.forEach((element) => {
        if (element.productId == this.selectedProductForScan.productId && element.purchaseOrderId == this.selectedProductForScan.purchaseOrderId) {
          element.ReceivedPurchaseOrderSerialDetail = [];
          this.autoGenerateLists.forEach((nl) => {
            const obj = {
              id: (nl.id ? nl.id : 0),
              createdSource: this.app.userIP,
              updatedSource: this.app.userIP,
              createdBy: this.app.userId,
              updatedBy: this.app.userId,
              createdDate: new Date().toISOString(),
              updatedDate: new Date().toISOString(),
              receivedPurchaseOrderProductId: (this.selectedProductForScan.id ? this.selectedProductForScan.id : 0),
              barcode: nl.serialNo,
              serialNumber2: nl.serialNo2,
              serialNumber3: nl.serialNo3,
              serialNumber4: nl.serialNo4,
              serialNumber5: nl.serialNo5,
              serialNumber6: nl.serialNo6,
              serialNumber7: nl.serialNo7,
              serialNumber8: nl.serialNo8,
              serialNumber9: nl.serialNo9,
              serialNumber10: nl.serialNo10,
              serialNumber11: nl.serialNo11,
              serialNumber12: nl.serialNo12,
              serialNumber13: nl.serialNo13,
              serialNumber14: nl.serialNo14,
              serialNumber15: nl.serialNo15,
              serialNumber16: nl.serialNo16,
              serialNumber17: nl.serialNo17,
              lotNumber: nl.lotNo,
              revisionNumber: nl.revisionNo,
              expirationDate: this.app._saveDateTimeWithZone(nl.expiration),
              statusId: 1,
              referenceId: this.refId
            };
            element.ReceivedPurchaseOrderSerialDetail.push(obj);
          });
        }
      });
    }
    this.selectedProductForScan = null;
    this.selectedBundle = null;
    this.listLength = 0;
    this.displayScanInfo = false;
  }

  get isFormIncomplete(): boolean {
    return Object.keys(this.trackingForm.controls).some(key => {
      if (key === 'serialNo') return false;
      const control = this.trackingForm.get(key);
      const isRequired = control?.validator?.({} as AbstractControl)?.['required'];
      const isEmpty = !control?.value || control.value.toString().trim() === '';
      return isRequired && isEmpty;
    });
  }

  setMainHeaderTracking() {
    const checked = this.nameLists.filter(ch => ch.checked);
    if (checked.length == this.nameLists?.length) {
      this.allChecked = true;
    } else {
      this.allChecked = false;
    }
  }

  removeNumber(i) {
    this.nameLists.splice(i, 1);
    this.autoGenerateLists.splice(i, 1);
    this.nameLists = this.autoGenerateLists.slice(0, 100);
    this.listLength--;
    this.totalTBRecord = this.listLength;
    const totalQty = this.selectedProductForScan?.quantityReceive;
    this.trackingForm.controls['qty'].setValue(totalQty - this.listLength);
  }

  deleteAll() {
    this.autoGenerateLists = [];
    this.nameLists = [];
    this.listLength = 0;
    this.totalTBRecord = 0;
    const totalQty = this.selectedProductForScan?.quantityReceive;
    this.trackingForm.controls['qty'].setValue(totalQty);
  }

  setTableCheck() {
    for (let s of this.autoGenerateLists) {
      if (this.allChecked) {
        s.checked = true;
      } else {
        s.checked = false;
      }
    }
  }

  generate() {
    if (this.isFormIncomplete) {
      this.messageService.add({ severity: "error", summary: "Error", detail: "Please fill all required fields." });
      return
    }
    const length = (this.selectedProductForScan?.quantityReceive - this.listLength);
    this.autoGenerateLists = this.utilsService.autogenerateSerial(this.trackingForm.value, this.prefixValue, this.autoGenerateLists, length);
    for (let auto of this.autoGenerateLists) {
      auto.expiration = auto.expiration && new Date(auto.expiration);
    }
    this.totalTBRecord = this.autoGenerateLists.length;
    this.nameLists = this.autoGenerateLists.slice(0, 100);
    this.listLength = this.autoGenerateLists.length;
    this.trackingForm.controls['qty'].setValue(length - this.listLength);
  }

  loadSerialsLazy(event) {
    if (this.autoGenerateLists) {
      this.nameLists = this.autoGenerateLists.slice(
        event.first,
        event.first + event.rows
      );
    }
  }

  openImport() {
    this.importCount = (this.selectedProductForScan?.quantityReceive);
    this.displayImport = true;
  }

  hideImport() {
    this.displayImport = false;
  }

  checkBundle(bundle) {
    if (bundle.typeId == 4) {
      for (let prd of bundle.products) {
        if (prd.quantityReceive > 0 || prd.isClosed) {
          return true;
        }
      }
    }
    return false;
  }

  setRPO() {
    const product: any[] = [];
    this.receivePurchaseListTB.forEach(element => {
      if (element.quantityReceive > 0 || element.isClosed || this.checkBundle(element)) {
        const req = {
          id: element.id ?? 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          receivedPurchaseOrderId: this.rpoDetail.id,
          purchaseOrderId: element.purchaseOrderId,
          purchaseOrderNo: element.purchaseOrderNo,
          productId: element.productId,
          description: element.description,
          product: null,
          isClosed: element.isClosed,
          isForceClosed: element.isForceClosed,
          productUnitId: element.unit?.unitOfMeasureId,
          quantity: (element.typeId != 4 ? element.quantityReceive : 0),
          totalQty: (element.typeId != 4 ? (isNaN(element.quantityReceive * element.unit?.uomDetail?.value) ? 0 : element.quantityReceive * element.unit?.uomDetail?.value) : 0),
          pricePerProduct: (element.typeId != 4 ? element.pricePerProduct : 0),
          totalAmount: element.cost,
          netAmount: element.lineTotal,
          taxId: 0,
          taxRate: 0,
          taxTypeId: 0,
          taxFinancialId: 0,
          taxName: '',
          discountTypeId: 0,
          discountAmount: 0,
          discountId: 0,
          discountName: 0,
          discountFinancialId: 0,
          statusId: Status.Active,
          status: null,
          receivedPurchaseBundleDetail: (element.typeId == 4 ? this.setBundleProduct(element) : []),
          warehouseId: this.shipAddress?.id,
          warehouse: null,
          binId: 0,
          updateSerial: (element.ReceivedPurchaseOrderSerialDetail ? true : false),
          ReceivedPurchaseOrderSerialDetail: element.ReceivedPurchaseOrderSerialDetail,
          receivedPOProductSubTax: this.utilsService.setProductSubTax(element,this.allTaxRates, this.app,this.ordersVendorCountryNew, this.ordersVendorStateNew, this.shipAddress, this.rpoDetail),
        }
        product.push(req);
      }
    });
    return product;
  }

  setBundleProduct(value) {
    const bundles: any[] = [];
    value.products?.forEach(element => {
      if (element.quantityReceive > 0 || element.isClosed) {
        const product = {
          id: element.id ?? 0,
          receivedPurchaseOrderId: this.rpoDetail.id,
          purchaseOrderId: value.purchaseOrderId,
          purchaseOrderNo: value.purchaseOrderNo,
          receivedPurchaseOrderProductId: element.receivedPurchaseOrderProductId,
          productId: element.productId,
          subProductId: element.subProductId,
          productUnitId: element.unit?.unitOfMeasureId,
          quantity: element.quantityReceive,
          totalQty: (isNaN(element.quantityReceive * element.unit?.uomDetail?.value) ? 0 : element.quantityReceive * element.unit?.uomDetail?.value),
          pricePerProduct: element.pricePerProduct,
          totalAmount: element.cost,
          statusId: Status.Active,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          isClosed: element.isClosed,
          isForceClosed: element.isForceClosed,
          warehouseId: this.shipAddress?.id,
          binId: 0,
          description: element.description,
          taxId: 0,
          taxRate: 0,
          taxTypeId: 0,
          taxFinancialId: 0,
          taxName: '',
          discountTypeId: 0,
          discountAmount: 0,
          discountId: 0,
          discountFinancialId: 0,
          discountName: '',
          updateSerial: (element.receivedPurchaseOrderBundleSerialDetail ? true : false),
          receivedPurchaseOrderBundleSerialDetail: element.receivedPurchaseOrderBundleSerialDetail
        }
        bundles.push(product);
      }
    });
    return bundles;
  }

  setNotes(value) {
    const note: any[] = [];
    if (value.notes) {
      const notes = {
        id: 0,
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        receivedPurchaseOrderId: 0,
        userId: (value.userId ?? 0),
        noteId: 0,
        note: {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          comment: value.notes,
          isImportant: true,
          organizationId: this.app.companyId,
          description: '',
          statusId: Status.Active,
          status: null,
          isValid: true,
          validFromDate: new Date().toISOString(),
          validToDate: this.addYearPipe.transform(new Date()),
          noteComments: null,
          noteAttachments: null,
          createdByName: ''
        },
        statusId: Status.Active,
        status: null
      }
      note.push(notes);
    }
    return note;
  }

  checkRPOValidation() {
    const receiveInventory: any[] = [];
    for (let s of this.receivePurchaseListTB) {
      if (s.typeId != 4) {
        receiveInventory.push(s);
      } else if (s.typeId == 4) {
        for (let prd of s.products) {
          if ((!prd.isClosed && prd.quantityReceive > 0) || prd.isClosed) {
            receiveInventory.push(prd);
          }
        }
      }
    }

    const itemsWithNoPrice = receiveInventory?.filter(item => !item.isClosed && (Number(item.pricePerProduct) == 0 || item.quantityReceive == 0));
    if (itemsWithNoPrice.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  checkProductWithGreaterRecQty() {
    const isExtraReceived = this.receivePurchaseListTB?.some(prd => prd.quantityReceive > prd.quantity);
    return isExtraReceived;
  }

  checkTrackingMandatoryPrd() {
    const trackingAdded = this.receivePurchaseListTB?.some(prd => prd.trackingEnabled && prd.quantityReceive > 0
      && prd.ReceivedPurchaseOrderSerialDetail?.length != prd.quantityReceive);
    return trackingAdded;
  }

  saveReceivePO(value) {
    this.isDisabled = true;
    if (this.checkRPOValidation()) {
      if (this.utilsService.checkSerialNoValidationRPO(this.receivePurchaseListTB)) {
        if (!this.receiveGreaterQty && this.checkProductWithGreaterRecQty()) {
          this.messageService.add({
            severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error),
            detail: "To receive qty greater than ordered qty please update your I-Setting."
          });
          this.isDisabled = false;
          return;
        }
        if (this.poSerialEnabled && this.checkTrackingMandatoryPrd()) {
          this.messageService.add({
            severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error),
            detail: "Please add serial details to proceed."
          });
          this.isDisabled = false;
          return;
        }
        const req = {
          id: this.rpoDetail.id,
          userId: value.userId ?? 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: this.app._saveDateTimeWithZone(value.createdDate),
          updatedDate: new Date().toISOString(),
          number: '',
          name: '',
          description: '',
          organizationId: this.app.companyId,
          purchaseOrderId: this.receivePurchaseListTB[0].purchaseOrderId,
          purchaseOrder: null,
          warehouseId: this.shipAddress?.id,
          warehouse: null,
          contactId: value.contactId,
          contact: null,
          shippingAddressId: value.shippingAddressId,
          shippingAddress: null,
          totalAmount: this.subTotal,
          currencyUnitId: this.vendorDetails?.currencyId,
          exchangeRate: this.orgCurrency?.find(cr => cr.currencyId == this.vendorDetails?.currencyId)?.exchangeRate ?? 0,
          currencyUnit: null,
          discountTypeId: this.selectedValueOption?.discountBy ?? 0,
          discountType: null,
          discountId: (this.discount > 0 && this.selectedValueOption) ? this.selectedValueOption?.id : 0,
          discountName: (this.discount > 0 ? this.allDiscounts?.find(discount => discount.discountBy === this.selectedValueOption?.id)?.name : ''),
          discountAmount: this.discount,
          discountFinancialId: (this.discount > 0 ? this.allDiscounts?.find(discount => discount.discountBy === this.selectedValueOption?.id)?.incomeAccount : 0),
          shippingChargeAmount: this.shippingAmount,
          shippingFinancialId: (this.shippingAmount > 0 ? this.allFOBPoints?.find(f => f.isDefault)?.financialAccountId : 0),
          taxId: 0,
          taxAmount: this.tax,
          taxFinancialId: 0,
          taxName: '',
          otherChargeAmount: 0,
          netAmount: this.orderTotal,
          purchaseOrderStageId: 0,
          purchaseOrderStage: '',
          paymentTermId: (value?.paymentTermId ? value?.paymentTermId?.paymentTermId : 0),
          paymentTerm: null,
          paymentMethodId: (value.paymentMethodId ? value.paymentMethodId?.paymentMethodId : 0),
          paymentMethod: null,
          shippingTermId: (value.shippingTermId ? value.shippingTermId?.id : 0),
          shippingTerm: null,
          shippingMethodId: (value.shippingMethodId ? value.shippingMethodId?.shippingMethodId : 0),
          shippingMethod: null,
          statusId: Status.Active,
          status: null,
          isValid: true,
          isFullyReceived: this.setFullyReceivedRPO(),
          isBillCreated: !value.checkWithoutBill,
          validFromDate: new Date().toISOString(),
          validToDate: new Date().toISOString(),
          vendorId: value.vendorId?.id,
          vendorBusinessName: value.vendorId?.name,
          receivedPurchaseOrderProducts: this.setRPO(),
          receivedPurchaseOrderNotes: this.setNotes(value),
          configJson: JSON.stringify(this.itemReceiptTemplate),
          referenceNo: value.referenceNo,
          postingDate: this.isAllowPostingPeriod ? this.app._saveDateTimeWithZone(this.updatedPostingPeriodInfo?.postingDate) : this.rpoDetail?.postingDate,
          postingMonth: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingMonth : this.rpoDetail?.postingMonth,
          postingYear: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingYear : this.rpoDetail?.postingYear
        }
        this.purchaseService.updateReceivePurchaseOrder(req, (this.rpoDetail?.currencyUnitId == this.baseCurrency?.currencyId)).then(() => {
          this.displayPODialog = false;
          this.isDisabled = false;
          this.loadList.emit();
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: "Item Receipt created successfully..." });
        }).catch(() => {
          this.isDisabled = false;
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: "Error in saving data..." });
        });
      } else {
        this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: "Items you want to receive have more serialNo added than receive qty.." });
        this.isDisabled = false;
      }
    } else {
      this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: "Items you want to receive must have qty and price greater than 0..." });
      this.isDisabled = false;
    }
  }

  setFullyReceivedRPO() {
    const fullyReceivedProduct: any[] = [];
    this.receivePurchaseListTB.forEach(element => {
      if (element.typeId != 4 && (element.quantityPending == 0 || element.isClosed)) {
        fullyReceivedProduct.push(element);
      } else if (element.typeId == 4) {
        const fullyReceivedbundleProduct: any[] = [];
        for (let prd of element.products) {
          if (prd.quantityPending == 0 || prd.isClosed) {
            fullyReceivedbundleProduct.push(prd);
            if (fullyReceivedbundleProduct?.length == element.products?.length) {
              fullyReceivedProduct.push(element);
            }
          }
        }
      }
    });
    if (fullyReceivedProduct.length == this.receivePurchaseListTB.length) {
      return true
    } else {
      return false;
    }
  }


  importSerialData(data) {
    /*check whether same file is importing for all product in RPO*/
    for (let dt of data.list) {
      for (let prd of this.receivePurchaseListTB) {
        const prdDuplicate = prd.ReceivedPurchaseOrderSerialDetail?.filter(sNo => ((prd.productId != this.selectedProductForScan.productId || prd.purchaseOrderId != this.selectedProductForScan.purchaseOrderId) && sNo.barcode == dt.serialNo));
        if (prdDuplicate?.length > 0) {
          this.messageService.add({
            severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error),
            detail: "You are trying to import same serialNo for different product in RPO",
          });
          return
        }
      }
    }
    if (data.action == 'add') {
      for (let dt of data.list) {
        const index = this.autoGenerateLists?.findIndex(exp => exp.serialNo == dt.serialNo);
        if (index > -1) {
          dt.id = this.autoGenerateLists[index].id;
          this.autoGenerateLists[index] = dt;
        } else {
          if ((this.listLength < this.selectedProductForScan?.quantityReceive) && this.utilsService.hasSerialNo(dt.serialNo, this.systemTrackingData)) {
            this.autoGenerateLists.push(dt);
            this.listLength++;
          }
        }
      }
    } else {
      // Get the total quantity from the form control
      const totalQty = this.selectedProductForScan.quantityReceive || 0;
      const uniqueList = data.list?.filter(dt => this.utilsService.hasSerialNo(dt.serialNo, this.systemTrackingData));
      const filteredList = uniqueList.slice(0, totalQty);
      // Fields to skip when comparing
      const skipKeys = ['id', 'expiration', 'field1', 'field2', 'field3', 'field4', 'field5', 'field6', 'field7', 'field8',
        'field9', 'field10', 'field11', 'field12', 'field13', 'field14', 'field15', 'field16', 'field17', 'field18', 'field19',
        'field20'
      ];
      // Compare only defined + non-empty fields from newItem against existingItem
      const isMatch = (existingItem: any, newItem: any): boolean => {
        for (const key in newItem) {
          if (skipKeys.includes(key)) continue;

          const newVal = newItem[key];
          if (newVal !== undefined && newVal !== null && newVal !== '') {
            if (existingItem[key] !== newVal) return false;
          }
        }
        return true;
      };
      // Step 1: Update existing items
      let updatedList = this.autoGenerateLists.map(existingItem => {
        const match = filteredList.find(newItem => isMatch(existingItem, newItem));
        if (match) {
          return {
            ...existingItem,
            ...Object.keys(match).reduce((acc, key) => {
              acc[key] = match[key] !== undefined && match[key] !== ''
                ? match[key]
                : existingItem[key]; // preserve existing if new is blank
              return acc;
            }, {} as any)
          };
        }
        return existingItem;
      });
      // Step 2: Remove items not found in filteredList
      updatedList = updatedList.filter(existingItem =>
        filteredList.some(newItem => isMatch(existingItem, newItem))
      );
      // Step 3: Add new items not present in updatedList
      filteredList.forEach(newItem => {
        const exists = updatedList.some(existingItem => isMatch(existingItem, newItem));
        if (!exists) {
          updatedList.push(newItem);
        }
      });
      this.autoGenerateLists = updatedList;
    }
    this.nameLists = this.autoGenerateLists.slice(0, 100);
    this.totalTBRecord = this.listLength;
    this.disabledSave = false;
    this.displayImport = false;
    const totalQty = this.selectedProductForScan?.quantityReceive;
    this.trackingForm.controls['qty'].setValue(totalQty - this.listLength);
    this.messageService.add({
      severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success),
      detail: "Import successfully,removed duplicate Serial No.",
    });
  }

  saveImport(data) {
    this.refId = data.referenceId;
    //duplicate file import
    const unique = data.list?.filter((obj) => {
      const autoIndex = this.autoGenerateLists.findIndex(item => item.serialNo === obj.serialNo);
      const hasBlankSerialNo = this.autoGenerateLists.some(item => item.serialNo === "");

      return autoIndex === -1 || hasBlankSerialNo;
    }) || [];

    const qty = (this.selectedProductForScan?.quantityReceive - this.listLength);
    if (unique.length > 0 && (data.list?.length - unique.length) > qty) {
      this.confirmationService.confirm({
        message: "You cannot import serial numbers more than ordered qty,Do you still want to proceed?",
        header: "Alert Confirmation",
        icon: "pi pi-info-circle",
        accept: () => {
          this.importSerialData(data);
        },
        reject: () => { },
      });
    } else {
      this.importSerialData(data);
    }
  }

  closeDialog() {
    this.displayPODialog = false;
    this.onClose.emit();
  }

  setContentInEditor(text: any) {
    setTimeout(() => {
      const _quill = this.editor?.getQuill();
      const editorContainer = _quill?.root;
      this.renderer.setProperty(editorContainer, 'innerHTML', text);
    });
  }

  onPostingInfoChange(postingInfo: IPostingPeriodDetails) {
    this.updatedPostingPeriodInfo = postingInfo;
  }

  // Tax Selection
  async getTaxByAddress(countryId: number) {
    const taxData: any = await this.utilityService.getTaxByCountryId(countryId);
    this.taxSettings = taxData.taxSettings ?? null;
    this.allTaxRates = taxData?.allTaxRates ?? [];
    this.taxConfig = taxData.taxConfig ?? null;
  }

  openTax(product: any) {
    this.currentProduct = product;
    this.selectedTax = product?.productSubTax ?? [];
    this.taxDialogContext = 'product';
    this.displayTaxSelectionDialog = true;
  }

  openFooterTax() {
    const allTaxes = this.receivePurchaseListTB?.flatMap((product) => {
      return product.productSubTax ?? [];
    });
    this.selectedTax = this.getUniqueTaxes(allTaxes);
    this.taxDialogContext = 'footer';
    this.displayTaxSelectionDialog = true;
  }

  private getUniqueTaxes(taxes: any[]): any[] {
    const uniqueTaxMap = new Map();
    taxes?.forEach((tax) => {
      if (!uniqueTaxMap.has(tax.taxId)) {
        uniqueTaxMap.set(tax.taxId, tax);
      }
    });
    return Array.from(uniqueTaxMap.values());
  }

  applyTax(event: TaxSelectionModel) {
    this.displayTaxSelectionDialog = false;
    this.selectedTax = null;
    if (this.taxDialogContext === 'product') {
      this.currentProduct.productSubTax = event.selectedTaxes;
      this.currentProduct.isManualTaxApplied = true;
      this.calculateProductPrice(this.currentProduct);
    } else if (this.taxDialogContext === 'footer') {
      this.receivePurchaseListTB = this.receivePurchaseListTB.map(product => ({
        ...product,
        productSubTax: event.selectedTaxes,
        isManualTaxApplied: true
      }));
      this.receivePurchaseListTB?.forEach((item) => {
        let productsTotalTax = 0;
        item?.productSubTax?.forEach((sTax) => {
          productsTotalTax += this.utilityService.calculateProductsTax(sTax.taxRate, item.cost);
        });
        item.taxAmount = productsTotalTax;
      })
      this.findsum(this.receivePurchaseListTB);
    }
  }

  onCloseTaxSelectionDialog(event: any) {
    this.displayTaxSelectionDialog = false;
  }
  // End of Tax Selection
}
